import { IconButton, Badge, Tooltip } from "@mui/material";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import { useNavigate } from "react-router-dom";
import { useAuthentication, useActiveOrders } from "hooks";

export function NavbarOrdersButton() {
  const { user } = useAuthentication();
  const navigate = useNavigate();
  const { badgeColor, badgeCount, tooltip } = useActiveOrders(user?.uid);

  return (
    <Tooltip title={tooltip} arrow>
      <IconButton
        onClick={() => navigate("/profile/orders")}
        disabled={!user}
        size="small"
        color={badgeColor ? "primary" : "default"}
      >
        <Badge
          badgeContent={badgeCount > 0 ? badgeCount : null}
          color={badgeColor ?? "default"}
          max={9}
        >
          <ReceiptLongIcon fontSize="small" />
        </Badge>
      </IconButton>
    </Tooltip>
  );
}
